import React, { useEffect, useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { CButton, CCardBody } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'
import { path } from '../../../../libs'
import { Badge, Table } from 'antd'
import { Client, ExchangerTransfer } from './types'
import { currencyFilterList } from '../../const'
import { useExchangerTransfersList } from './hooks'
import { FilterValue } from 'antd/es/table/interface'
import { formatDigits } from '../../../../libs/utils'

const EXCHANGER_TRANSFERS_MOCKS = [
  {
    id: 1,
    client: {
      id: 1,
      fullName: 'James',
    },
    createdAt: '',
    updatedAt: '',
    type: 'exchanger',
    status: 'accept',
    exchangerAmount: '1111',
    exchangerCurrency: 'USD',
    clientAmount: '11111',
    clientCurrency: 'USD',
  },
]

export const ExchangerTransfersList = () => {
  const {
    exchangerTransfers,
    onChangeExchangerTransfersList,
    totalCountOfExchangerTransfers,
    loading,
  } = useExchangerTransfersList()

  const [searchText, setSearchText] = useState<{
    [key: string]: string
  }>({})
  const [orderBy, setOrderBy] = useState('id')
  const [orderDirection, setOrderDirection] = useState('-')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
    filters,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
    filters?: Record<string, FilterValue | null>
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }

    // if (filters) {
    //   setFiltersState(filters)
    // }
  }

  useEffect(() => {
    onChangeExchangerTransfersList({
      limit: pageSize,
      page: page,
      orderBy: orderBy,
      orderDirection: orderDirection,
      searchText: searchText,
    })
  }, [pageSize, page, orderBy, orderDirection, searchText])

  const columns: ColumnsType<ExchangerTransfer> = [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: 'descend',
    },
    {
      title: 'Client',
      children: [
        {
          title: 'ID',
          dataIndex: 'client',
          key: 'clientId',
          render: (item: Client) => (
            <div>
              {item?.isTest ? (
                <Badge count={'Test'} offset={[-10, -10]}>
                  <a
                    href={path.clients.details(String(item.clientId))}
                    target="_blank"
                  >
                    {item.clientId}
                  </a>
                </Badge>
              ) : (
                <a
                  href={path.clients.details(String(item.clientId))}
                  target="_blank"
                >
                  {item.clientId}
                </a>
              )}
            </div>
          ),
        },
        {
          title: 'Full name',
          dataIndex: 'client',
          key: 'client.fullName',
          render: (item: Client) => (
            <>
              <div>{item.fullName}</div>
            </>
          ),
        },
      ],
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Created at',
      dataIndex: 'createdAt',
      render: (createdAt: string, record: ExchangerTransfer) =>
        record?.humanCreatedAt,
    },
    {
      title: 'Updated at',
      dataIndex: 'updatedAt',
      render: (updatedAt: string, record: ExchangerTransfer) =>
        record?.humanUpdatedAt,
    },
    {
      title: 'Exchanger amount',
      children: [
        {
          title: 'Amount',
          dataIndex: 'destinationAmount',
          render: (destinationAmount: string) => (
            <>{formatDigits(Number(destinationAmount))}</>
          ),
        },
        {
          title: 'Currency',
          dataIndex: 'destinationCurrency',
          filters: currencyFilterList,
          filterSearch: true,
          render: (destinationCurrency: string) => <>{destinationCurrency}</>,
          onFilter: (value: any, record) => record.destinationCurrency == value,
        },
      ],
    },
    {
      title: 'Client amount',
      children: [
        {
          title: 'Amount',
          dataIndex: 'sourceAmount',
          render: (sourceAmount: string) => (
            <>{formatDigits(Number(sourceAmount))}</>
          ),
        },
        {
          title: 'Currency',
          dataIndex: 'sourceCurrency',
          filters: currencyFilterList,
          filterSearch: true,
          render: (sourceCurrency: string) => <>{sourceCurrency}</>,
          onFilter: (value: any, record) => record.sourceCurrency == value,
        },
      ],
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 100,
      render: (item) => {
        return (
          <>
            <CButton
              color="secondary"
              className="me-2"
              title="View"
              href={path.billing.exchangerTransfer.details(item.id)}
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <Table
        dataSource={exchangerTransfers}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="exchangerTransfersId"
        columns={columns}
        pagination={{
          showSizeChanger: true,
          total: totalCountOfExchangerTransfers,
        }}
        onChange={(pagination, filters, sorter, extra) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current,
            //@ts-ignore
            currentPageSize: pagination.pageSize,
            //@ts-ignore
            currentOrderDirection: sorter.order,
            //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
      ></Table>
    </CCardBody>
  )
}
